// ZERAMI official logo (color mark + wordmark).
export const Logo = ({ className = "", chip = false, height = 40 }) => {
  const img = (
    <img
      src="/logo-zerami.png"
      alt="ZERAMI"
      style={{ height }}
      className="w-auto object-contain"
      data-testid="zerami-logo"
    />
  );
  if (chip) {
    return (
      <span className={`inline-flex items-center rounded-lg bg-white px-3 py-1.5 shadow-sm ${className}`}>
        {img}
      </span>
    );
  }
  return <span className={`inline-flex items-center ${className}`}>{img}</span>;
};
